import { action } from 'satcheljs';

export default action(
    'insertNodeFromExpressionPicker',
    (composeId: string, wordToReplace: any, node: HTMLElement, range?: Range) => ({
        composeId,
        wordToReplace,
        node,
        range,
    })
);
